import { Text } from '@chakra-ui/react';

export const GroupHostedEventMessage: React.FC = () => {
  return (
    <Text>
      This is a group-hosted event. Registration is limited to group members.
    </Text>
  );
};

